import { connect } from 'react-redux';
import React, { Component } from 'react';

import { closeModalSafetypay } from '../../../actions/purchaseActions';

export class ModalSafetypay extends Component {
  render() {
    if (!this.props.isModalSafetypayActive) return <div />;

    return (
      <div className="comp_modalpagamento safetypay-modal">
        <div className="modalcontents">
          <div className="contents">
            <div className="modaltop">
              <div className="title">Instruções para pagamento via SafetyPay</div>
              <div onClick={this.props.closeModalSafetypay} className={`close-btn ${this.props.mobile && ' mobile'}`}>
                {' '}
                &times;{' '}
              </div>
            </div>
            <div className="modalmiddle">
              <p className="modallist">
                <div className="listcontents">
                  <div className="listline">
                    <div className="ico">
                      <img src="/assets/images/valor-safety.svg" alt="" />
                    </div>
                    <div className="text">
                      <span>Transfira o valor exato da sua compra</span>
                    </div>
                  </div>
                  <div className="listline">
                    <div className="ico">
                      <img src="/assets/images/not-allowed.svg" alt="" />
                    </div>
                    <div className="text">
                      <strong>Não </strong>
                      <span>utilize contas de Pessoa Jurídica</span>
                    </div>
                  </div>
                  <div className="listline">
                    <div className="ico">
                      <img src="/assets/images/not-allowed.svg" alt="" />
                    </div>
                    <div className="text">
                      <strong>Não </strong>
                      <span>utilize Conta Poupança</span>
                    </div>
                  </div>
                  <div className="listline">
                    <div className="ico">
                      <img src="/assets/images/not-allowed.svg" alt="" />
                    </div>
                    <div className="text">
                      <span>
                        Pague somente por meio do Internet Banking do banco acima. Não disponível para caixa eletrônico,
                        telefone ou pela agência bancária.
                      </span>
                    </div>
                  </div>
                </div>
              </p>
            </div>
            <div className="modalbotton">
              <strong>
                Importante <br />{' '}
              </strong>
              <div>
                Para prosseguir com a contratação, é necessário concordar com os termos e condições de uso de cada
                seguradora.
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    isModalSafetypayActive: state.purchase.isModalSafetypayActive,
    mobile: state.mobile.mobileActive,
  }),
  {
    closeModalSafetypay,
  }
)(ModalSafetypay);



// WEBPACK FOOTER //
// ./src/components/purchase/modal_safetypay/ModalSafetypay.jsx